import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';

/**
 * @summary PermissionCheckMark
 * @extends {AoflElement}
 */
@customElement('permission-check-mark')
class PermissionCheckMark extends AoflElement {
  /**
   * Creates an instance of PermissionCheckMark.
   */
  constructor() {
    super();
  }
  /**
   * @readonly
   */
  static is = 'permission-check-mark';

  @property({type: String, attribute: false})
  state = '';
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default PermissionCheckMark;
